module.exports = __webpack_public_path__ + "img/i-4.f576a044.svg";